<template>
<v-container>
    <v-layout justify-center align-center fill-height row wrap>
      <v-flex xs12>
        <p class="text-xs-center headline">Din păcate nu ai o conexiune bună la internet</p>
      </v-flex>
      <v-flex class="text-xs-center" xs12>
        <v-btn color="pink" class="white--text" @click="retry()">Reîncearcă</v-btn>
      </v-flex>
    </v-layout>
</v-container>
</template>

<script>
  export default {
    data: () => ({

    }),

    methods: {
      retry() {
        this.$router.push({path: this.$store.state.fromPage ? this.$store.state.fromPage : '/'}); // We should redirect to visits page? to the last page
      }
    },

    created() {
      this.$store.commit('CENTER_VIEW_VERTICAL', true);
    }
  };
</script>